import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import messages from 'src/pages/SetupPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

export interface fieldCategoryParamsType {
  nameEn: string;
  nameDe: string;
  position: number;
}

const createFieldCategory = async (fieldCategory: fieldCategoryParamsType) => {
  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.createFieldCategory,
    fieldCategoryParamsBuilder(fieldCategory),
    { headers: { Accept: 'application/vnd.falcon.v1+json' } },
  );

  return data;
};

export const useCreateFieldCategory = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createFieldCategory,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.fieldCategorySaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FIELD_CATEGORIES] });
    },
    onError: handleError,
  });
};

export const fieldCategoryParamsBuilder = (
  fieldCategory: fieldCategoryParamsType,
) => {
  return {
    category: {
      name_en: fieldCategory.nameEn,
      name_de: fieldCategory.nameDe,
      position: parseInt(fieldCategory.position.toString(), 10),
    },
  };
};
